
/* ============================================================
   OptiSil Lens Designer — merged engine + UI
   ============================================================ */

/* ---------- validated optics engine ---------- */
function ldSag(r, R, flat, k, A4, A6) {
  if (flat || !isFinite(R)) return 0;
  var c = 1 / R, r2 = r * r;
  var disc = 1 - (1 + k) * c * c * r2;
  if (disc < 0) return NaN;
  return (c * r2) / (1 + Math.sqrt(disc)) + A4 * r2 * r2 + A6 * r2 * r2 * r2;
}
function ldSlope(r, R, flat, k, A4, A6) {
  if (flat || !isFinite(R)) return 0;
  var c = 1 / R;
  var disc = 1 - (1 + k) * c * c * r * r;
  if (disc < 0) return NaN;
  return (c * r) / Math.sqrt(disc) + 4 * A4 * r * r * r + 6 * A6 * r * r * r * r * r;
}
function ldNormalize(v) { var m = Math.hypot(v[0], v[1]) || 1; return [v[0]/m, v[1]/m]; }
function ldDot(a,b){ return a[0]*b[0]+a[1]*b[1]; }
function ldRefract(d, N, n1, n2) {
  var Nn = N.slice();
  var cosi = -ldDot(Nn, d);
  if (cosi < 0) { Nn = [-Nn[0], -Nn[1]]; cosi = -cosi; }
  var eta = n1 / n2;
  var k = 1 - eta*eta*(1 - cosi*cosi);
  if (k < 0) return null;
  var cost = Math.sqrt(k);
  return ldNormalize([eta*d[0] + (eta*cosi - cost)*Nn[0], eta*d[1] + (eta*cosi - cost)*Nn[1]]);
}
function ldIntersect(P0, d0, guessS, surfFn) {
  var s = guessS;
  for (var i = 0; i < 30; i++) {
    var r = P0[1] + s * d0[1];
    var x = surfFn(r);
    if (isNaN(x)) return null;
    var newS = (x - P0[0]) / d0[0];
    if (Math.abs(newS - s) < 1e-9) { s = newS; break; }
    s = newS;
  }
  var r = P0[1] + s * d0[1];
  var x = surfFn(r);
  if (isNaN(x)) return null;
  return { P: [P0[0] + s*d0[0], r], r: r };
}
function ldTraceRay(P0, d0, lens) {
  function front(r){ return ldSag(r, lens.R1, lens.r1flat, lens.k1, lens.A4_1, lens.A6_1); }
  function back(r){ return lens.t + ldSag(r, lens.R2, lens.r2flat, lens.k2, lens.A4_2, lens.A6_2); }
  var guess1 = (0 - P0[0]) / d0[0];
  var hit1 = ldIntersect(P0, d0, guess1, front);
  if (!hit1) return { clipped: 'aperture_front' };
  var P1 = hit1.P, r1 = hit1.r;
  if (Math.abs(r1) > lens.diameter/2) return { clipped: 'aperture_front', P1: P1 };
  var sl1 = ldSlope(r1, lens.R1, lens.r1flat, lens.k1, lens.A4_1, lens.A6_1);
  var N1 = ldNormalize([-1, isNaN(sl1) ? 0 : sl1]);
  var d1 = ldRefract(d0, N1, 1.0, lens.n);
  if (!d1) return { clipped: 'tir_entry', P1: P1 };
  var guess2 = (lens.t - P1[0]) / d1[0];
  var hit2 = ldIntersect(P1, d1, guess2, back);
  if (!hit2) return { clipped: 'aperture_back', P1: P1 };
  var P2 = hit2.P, r2 = hit2.r;
  if (Math.abs(r2) > lens.diameter/2) return { clipped: 'aperture_back', P1: P1, P2: P2 };
  var sl2 = ldSlope(r2, lens.R2, lens.r2flat, lens.k2, lens.A4_2, lens.A6_2);
  var N2 = ldNormalize([-1, isNaN(sl2) ? 0 : sl2]);
  var d2 = ldRefract(d1, N2, lens.n, 1.0);
  if (!d2) return { clipped: 'tir_exit', P1: P1, P2: P2 };
  return { P1: P1, P2: P2, d1: d1, d2: d2, r1: r1, r2: r2 };
}
function ldBuildRay(h, source) {
  if (source.type === 'point') {
    var L = source.objDist;
    return { P0: [-L, 0], d0: ldNormalize([L, h]) };
  } else if (source.type === 'angled') {
    var th = source.angleDeg * Math.PI/180;
    var d0 = [Math.cos(th), Math.sin(th)];
    var aim = [0, h];
    return { P0: [aim[0]-1000*d0[0], aim[1]-1000*d0[1]], d0: d0 };
  }
  return { P0: [-1000, h], d0: [1,0] };
}
function ldRayLineParam(P, d, Pc, dc) {
  var det = d[0]*dc[1] - dc[0]*d[1];
  if (Math.abs(det) < 1e-12) return null;
  var dx = P[0]-Pc[0], dy = P[1]-Pc[1];
  return (dc[0]*dy - dc[1]*dx)/det;
}
function ldThickEFL(R1,R2,n,t) {
  var f1 = Math.abs(R1) < 1e14, f2 = Math.abs(R2) < 1e14;
  var a = f1 ? (n-1)/R1 : 0, b = f2 ? (n-1)/R2 : 0;
  var c = (f1 && f2) ? (n-1)*(n-1)*t/(n*R1*R2) : 0;
  var invF = a - b + c;
  return invF === 0 ? Infinity : 1/invF;
}
function ldBFD(f,R1,n,t){ return Math.abs(R1)>1e14 ? f : f*(1-(n-1)*t/(n*R1)); }
function ldFFD(f,R2,n,t){ return Math.abs(R2)>1e14 ? Math.abs(f) : Math.abs(f)*(1-(n-1)*t/(n*(-R2))); }

/* ---------- state ---------- */
var LD = {
  diameter: 30, t: 6,
  R1: 60, r1flat: false, k1: 0, A4_1: 0, A6_1: 0,
  R2: -60, r2flat: false, k2: 0, A4_2: 0, A6_2: 0,
  n: 1.460,
  shape: 'biconvex',
  sourceType: 'collimated',
  objDist: 200, angleDeg: 15
};

var LD_MATERIALS = [
  { label: 'Optical Silicone (standard)', n: 1.460 },
  { label: 'Soft Silicone (low-index)',   n: 1.410 },
  { label: 'High-Index Silicone',         n: 1.550 },
  { label: 'BK7 Optical Glass',           n: 1.517 },
  { label: 'Fused Silica',                n: 1.458 },
  { label: 'Acrylic (PMMA)',              n: 1.491 },
  { label: 'Polycarbonate',               n: 1.585 },
  { label: 'Sapphire',                    n: 1.770 },
  { label: 'Flint Glass (F2)',            n: 1.617 },
  { label: 'Dense Flint (SF11)',          n: 1.785 }
];

var LD_SHAPES = [
  { key: 'biconvex',      label: 'Biconvex' },
  { key: 'biconcave',     label: 'Biconcave' },
  { key: 'planoconvex',   label: 'Plano-Convex' },
  { key: 'planoconcave',  label: 'Plano-Concave' },
  { key: 'meniscus_conv', label: 'Meniscus (converging)' },
  { key: 'meniscus_div',  label: 'Meniscus (diverging)' }
];

function ldApplyShapePreset(key) {
  LD.shape = key;
  var mag1 = Math.abs(LD.R1) < 1e14 ? Math.abs(LD.R1) : 60;
  var mag2 = Math.abs(LD.R2) < 1e14 ? Math.abs(LD.R2) : 60;
  LD.r1flat = false; LD.r2flat = false;
  switch (key) {
    case 'biconvex':      LD.R1 = mag1;  LD.R2 = -mag2; break;
    case 'biconcave':     LD.R1 = -mag1; LD.R2 = mag2;  break;
    case 'planoconvex':   LD.R1 = mag1;  LD.r2flat = true; break;
    case 'planoconcave':  LD.R1 = -mag1; LD.r2flat = true; break;
    case 'meniscus_conv': LD.R1 = mag1;  LD.R2 = mag2 * 1.4; break;
    case 'meniscus_div':  LD.R1 = -mag1; LD.R2 = -mag2 * 1.4; break;
  }
}

/* ---------- derived optics ---------- */
function ldOptics(s) {
  var R1e = s.r1flat ? Infinity : s.R1;
  var R2e = s.r2flat ? Infinity : s.R2;
  var f = ldThickEFL(R1e, R2e, s.n, s.t);
  var BFD = ldBFD(f, R1e, s.n, s.t);
  var FFD = ldFFD(f, R2e, s.n, s.t);
  var c1 = s.r1flat ? 0 : 1/s.R1;
  var c2 = s.r2flat ? 0 : 1/s.R2;
  var thinPower = (s.n - 1) * (c1 - c2);
  var fThin = thinPower !== 0 ? 1/thinPower : Infinity;
  var powerD = isFinite(f) ? 1000/f : 0;
  var fnum = (isFinite(f) && f > 0) ? f / s.diameter : NaN;
  var NA = (isFinite(BFD) && BFD > 0) ? Math.sin(Math.atan2(s.diameter/2, BFD)) : NaN;
  return { f: f, BFD: BFD, FFD: FFD, fThin: fThin, powerD: powerD, fnum: fnum, NA: NA, c1: c1, c2: c2 };
}
function ldClassify(s, o) {
  var shape;
  if (s.r1flat && s.r2flat) shape = 'Flat Plate';
  else if (s.r1flat) shape = o.c2 < 0 ? 'Plano-Convex' : 'Plano-Concave';
  else if (s.r2flat) shape = o.c1 > 0 ? 'Plano-Convex' : 'Plano-Concave';
  else if (s.R1 > 0 && s.R2 < 0) shape = 'Biconvex';
  else if (s.R1 < 0 && s.R2 > 0) shape = 'Biconcave';
  else shape = 'Meniscus';
  var behavior;
  if (!isFinite(o.f)) behavior = 'Afocal';
  else behavior = o.f > 0 ? 'Converging (+)' : 'Diverging (\u2212)';
  return { shape: shape, behavior: behavior };
}

/* ---------- ray bundle ---------- */
function ldTraceBundle(s) {
  var rmax = s.diameter / 2;
  var fracs = [0.15, 0.4, 0.65, 0.9];
  var heights = [0].concat(fracs.map(function(f){return f*rmax;})).concat(fracs.map(function(f){return -f*rmax;}));
  var source = s.sourceType === 'point' ? { type:'point', objDist: s.objDist } :
               s.sourceType === 'angled' ? { type:'angled', angleDeg: s.angleDeg } :
               { type:'collimated' };
  var chiefDef = ldBuildRay(0, source);
  var chief = ldTraceRay(chiefDef.P0, chiefDef.d0, s);
  var rays = heights.map(function(h){
    var built = ldBuildRay(h, source);
    var tr = ldTraceRay(built.P0, built.d0, s);
    var u = null, point = null, real = null;
    if (h !== 0 && !tr.clipped && chief && !chief.clipped) {
      u = ldRayLineParam(tr.P2, tr.d2, chief.P2, chief.d2);
      if (u !== null) { point = [tr.P2[0]+u*tr.d2[0], tr.P2[1]+u*tr.d2[1]]; real = u > 0; }
    }
    return { h: h, t: tr, u: u, point: point, real: real };
  });
  var realPts = rays.filter(function(r){return r.real===true;}).map(function(r){return r.point;});
  var virtPts = rays.filter(function(r){return r.real===false;}).map(function(r){return r.point;});
  var conv = null;
  function avg(arr,i){ return arr.reduce(function(a,p){return a+p[i];},0)/arr.length; }
  if (realPts.length) conv = { x: avg(realPts,0), y: avg(realPts,1), real: true };
  else if (virtPts.length) conv = { x: avg(virtPts,0), y: avg(virtPts,1), real: false };
  var tirCount = rays.filter(function(r){ return r.t.clipped === 'tir_entry' || r.t.clipped === 'tir_exit'; }).length;
  var apertureClipCount = rays.filter(function(r){ return r.t.clipped === 'aperture_front' || r.t.clipped === 'aperture_back'; }).length;
  return { rays: rays, chief: chief, conv: conv, tirCount: tirCount, apertureClipCount: apertureClipCount };
}
function ldFocusSpread(bundle, rmax) {
  var p1 = bundle.rays.filter(function(r){ return Math.abs(r.h - 0.15*rmax) < 1e-6 && r.point; })[0];
  var p2 = bundle.rays.filter(function(r){ return Math.abs(r.h - 0.9*rmax) < 1e-6 && r.point; })[0];
  if (p1 && p2) return Math.hypot(p2.point[0]-p1.point[0], p2.point[1]-p1.point[1]);
  return null;
}

/* ---------- dynamic diameter limit (prevents invalid geometry) ---------- */
function ldMaxValidDiameter(s) {
  var lo = 8, hi = 150;
  function edgeOK(D) {
    var rmax = D / 2;
    var z1e = ldSag(rmax, s.R1, s.r1flat, s.k1, s.A4_1, s.A6_1);
    var z2e = ldSag(rmax, s.R2, s.r2flat, s.k2, s.A4_2, s.A6_2);
    if (isNaN(z1e) || isNaN(z2e)) return false;
    return ((s.t + z2e) - z1e) > 0.05;
  }
  if (edgeOK(hi)) return hi;
  if (!edgeOK(lo)) return lo;
  for (var i = 0; i < 40; i++) {
    var mid = (lo + hi) / 2;
    if (edgeOK(mid)) { lo = mid; } else { hi = mid; }
  }
  return lo;
}

/* ---------- manufacturability warnings ---------- */
function ldWarnings(s) {
  var rmax = s.diameter/2;
  var z1e = ldSag(rmax, s.R1, s.r1flat, s.k1, s.A4_1, s.A6_1);
  var z2e = ldSag(rmax, s.R2, s.r2flat, s.k2, s.A4_2, s.A6_2);
  var list = [];
  var edgeThickness = null, slope1deg = null, slope2deg = null;
  if (isNaN(z1e) || isNaN(z2e)) {
    list.push('Aperture exceeds the optical clear radius of a surface \u2014 reduce diameter, increase |R|, or reduce the conic constant.');
  } else {
    edgeThickness = (s.t + z2e) - z1e;
    if (edgeThickness <= 0) {
      list.push('Surfaces intersect within the aperture \u2014 invalid geometry. Increase center thickness, reduce diameter, or adjust radii.');
    } else if (edgeThickness < 0.5) {
      list.push('Edge thickness is under 0.5\u2009mm \u2014 check against the minimum moldable wall thickness for your process.');
    }
    var sl1 = ldSlope(rmax, s.R1, s.r1flat, s.k1, s.A4_1, s.A6_1);
    var sl2 = ldSlope(rmax, s.R2, s.r2flat, s.k2, s.A4_2, s.A6_2);
    slope1deg = Math.atan(sl1) * 180/Math.PI;
    slope2deg = Math.atan(sl2) * 180/Math.PI;
    if (Math.abs(slope1deg) > 65 || Math.abs(slope2deg) > 65) {
      list.push('Edge surface angle exceeds 65\u00b0 \u2014 steep edges are difficult to demould cleanly from a silicone tool. Consider a shallower radius or smaller diameter.');
    }
  }
  if (s.n <= 1.0) list.push('Refractive index must be greater than 1.');
  if (s.sourceType === 'angled' && Math.abs(s.angleDeg) > 35) {
    list.push('Field angle is large \u2014 the ray fan may miss the aperture, or paraxial approximations below may not hold.');
  }
  return { list: list, edgeThickness: edgeThickness, slope1deg: slope1deg, slope2deg: slope2deg, rmax: rmax };
}

/* ---------- formatting ---------- */
function ldFmt(x, dec) {
  if (dec === undefined) dec = 2;
  if (x === null || x === undefined || isNaN(x)) return '\u2014';
  if (!isFinite(x)) return x > 0 ? '+\u221e' : (x < 0 ? '\u2212\u221e' : '\u221e');
  return (x > 0 ? '+' : '') + x.toFixed(dec);
}

/* ---------- SVG rendering ---------- */
var LD_VB_W = 900, LD_VB_H = 480;

function ldBuildSVG(s, o, bundle, warn, focusSpread) {
  var cx = 300, cy = LD_VB_H/2, rmax = s.diameter/2;
  var scale = Math.min(7.5, (LD_VB_H*0.42)/rmax);
  var NS = 100;

  function frontX(y){ var z = ldSag(y, s.R1, s.r1flat, s.k1, s.A4_1, s.A6_1); return isNaN(z) ? null : cx + z*scale; }
  function backX(y){ var z = ldSag(y, s.R2, s.r2flat, s.k2, s.A4_2, s.A6_2); return isNaN(z) ? null : cx + (s.t + z)*scale; }
  function px(x){ return cx + x*scale; }
  function py(y){ return cy - y*scale; }

  var svg = [];
  svg.push('<rect x="0" y="0" width="'+LD_VB_W+'" height="'+LD_VB_H+'" fill="none"/>');

  // optical axis
  svg.push('<line x1="8" y1="'+cy+'" x2="'+(LD_VB_W-8)+'" y2="'+cy+'" stroke="rgba(74,127,165,0.28)" stroke-width="1" stroke-dasharray="5,4"/>');

  // lens body fill + outline (sampled at NS steps, skip if aperture invalid)
  var top=[], bot=[], valid=true;
  for (var i=0;i<=NS;i++){
    var yy = rmax*(i/NS);
    var fx = frontX(yy), bx = backX(yy);
    if (fx===null || bx===null) { valid=false; break; }
    top.push([fx,py(yy)]); bot.push([bx,py(yy)]);
  }
  if (valid) {
    function arcPath(pts) {
      // pts[0] = vertex, pts[last] = edge. Trace edge -> vertex -> mirrored-edge
      // as one continuous curve (no straight chord across the aperture).
      var upper = pts.slice().reverse(); // edge -> ... -> vertex
      var lowerMirrored = pts.slice(1);  // vertex+1 -> ... -> edge, y mirrored below
      var d = upper.map(function(p,i){return (i===0?'M':'L')+p[0].toFixed(2)+','+p[1].toFixed(2);}).join(' ');
      d += ' ' + lowerMirrored.map(function(p){return 'L'+p[0].toFixed(2)+','+(2*cy-p[1]).toFixed(2);}).join(' ');
      return d;
    }
    var frontPath = arcPath(top);
    var backPath = arcPath(bot);
    svg.push('<path d="'+frontPath+'" fill="none" stroke="#4a7fa5" stroke-width="2"/>');
    svg.push('<path d="'+backPath+'" fill="none" stroke="#4a7fa5" stroke-width="2"/>');
    // edge caps
    svg.push('<line x1="'+top[NS][0].toFixed(2)+'" y1="'+top[NS][1].toFixed(2)+'" x2="'+bot[NS][0].toFixed(2)+'" y2="'+bot[NS][1].toFixed(2)+'" stroke="#4a7fa5" stroke-width="1.5"/>');
    svg.push('<line x1="'+top[NS][0].toFixed(2)+'" y1="'+(2*cy-top[NS][1]).toFixed(2)+'" x2="'+bot[NS][0].toFixed(2)+'" y2="'+(2*cy-bot[NS][1]).toFixed(2)+'" stroke="#4a7fa5" stroke-width="1.5"/>');
  } else {
    svg.push('<text x="'+cx+'" y="'+cy+'" text-anchor="middle" font-family="IBM Plex Mono, monospace" font-size="11" fill="#c44">Geometry invalid at this aperture \u2014 see warnings</text>');
  }

  // diameter label -- sits directly above the lens, no connecting line
  // (a vertical tick used to sit in the open notch of concave surfaces and
  // read as if it were marking some kind of gap)
  svg.push('<text x="'+cx+'" y="'+(py(rmax)-10)+'" text-anchor="middle" font-family="IBM Plex Mono, monospace" font-size="10" fill="rgba(74,127,165,0.55)">\u00d8'+s.diameter.toFixed(0)+'mm</text>');

  // focal marks (paraxial, only if within view)
  function focalMark(fx, label) {
    if (!isFinite(fx) || fx < 10 || fx > LD_VB_W-10) return;
    svg.push('<line x1="'+fx.toFixed(1)+'" y1="'+(cy-20)+'" x2="'+fx.toFixed(1)+'" y2="'+(cy+20)+'" stroke="rgba(196,68,68,0.55)" stroke-width="1.3" stroke-dasharray="4,3"/>');
    svg.push('<circle cx="'+fx.toFixed(1)+'" cy="'+cy+'" r="2.6" fill="rgba(196,68,68,0.6)"/>');
    svg.push('<text x="'+fx.toFixed(1)+'" y="'+(cy-24)+'" text-anchor="middle" font-family="IBM Plex Mono, monospace" font-size="10" fill="#c44">'+label+'</text>');
  }
  if (valid && isFinite(o.f)) {
    focalMark(px(s.t) + o.BFD*scale, "F'");
    focalMark(px(0) - o.FFD*scale, "F");
  }

  // ray-traced image point (from actual bundle convergence)
  if (bundle.conv) {
    var ix = px(bundle.conv.x), iy = py(bundle.conv.y);
    if (ix > 8 && ix < LD_VB_W-8 && iy > 8 && iy < LD_VB_H-8) {
      svg.push('<circle cx="'+ix.toFixed(1)+'" cy="'+iy.toFixed(1)+'" r="4" fill="'+(bundle.conv.real?'rgba(224,120,48,0.9)':'none')+'" stroke="rgba(224,120,48,0.9)" stroke-width="1.5" stroke-dasharray="'+(bundle.conv.real?'0':'2,2')+'"/>');
    }
  }

  // rays
  var rayColor = '#e07830';
  var leftEdge = 6;
  function clipStart(x1, y1, dirX, dirY) {
    // Walk backward from (x1,y1) along pixel-space direction (dirX,dirY) to x=leftEdge.
    if (Math.abs(dirX) < 1e-9) return [leftEdge, y1];
    var s = (leftEdge - x1) / dirX;
    return [leftEdge, y1 + s*dirY];
  }
  bundle.rays.forEach(function(ray){
    var tr = ray.t;
    if (tr.clipped === 'aperture_front') return;
    var dirPx = [1, 0], truePx = null;
    if (s.sourceType !== 'collimated') {
      var built = ldBuildRay(ray.h, s.sourceType==='point' ? {type:'point',objDist:s.objDist} : {type:'angled',angleDeg:s.angleDeg});
      dirPx = [built.d0[0]*scale, -built.d0[1]*scale];
      truePx = [px(built.P0[0]), py(built.P0[1])];
    }
    if (tr.P1) {
      var x1 = px(tr.P1[0]), y1 = py(tr.P1[1]);
      var start = (truePx && truePx[0] >= leftEdge) ? truePx : clipStart(x1, y1, dirPx[0], dirPx[1]);
      svg.push('<line x1="'+start[0].toFixed(1)+'" y1="'+start[1].toFixed(1)+'" x2="'+x1.toFixed(1)+'" y2="'+y1.toFixed(1)+'" stroke="'+rayColor+'" stroke-width="1.4" opacity="0.75"/>');
    }
    if (tr.clipped === 'tir_entry') {
      if(tr.P1) svg.push('<circle cx="'+px(tr.P1[0]).toFixed(1)+'" cy="'+py(tr.P1[1]).toFixed(1)+'" r="3" fill="#c44"/>');
      return;
    }
    if (tr.P1 && tr.P2) {
      var x1b = px(tr.P1[0]), y1b = py(tr.P1[1]), x2b = px(tr.P2[0]), y2b = py(tr.P2[1]);
      svg.push('<line x1="'+x1b.toFixed(1)+'" y1="'+y1b.toFixed(1)+'" x2="'+x2b.toFixed(1)+'" y2="'+y2b.toFixed(1)+'" stroke="'+rayColor+'" stroke-width="1.4" opacity="0.75"/>');
    }
    if (tr.clipped === 'aperture_back') return;
    if (tr.clipped === 'tir_exit') {
      if(tr.P2) svg.push('<circle cx="'+px(tr.P2[0]).toFixed(1)+'" cy="'+py(tr.P2[1]).toFixed(1)+'" r="3" fill="#c44"/>');
      return;
    }
    if (tr.P2 && tr.d2) {
      var extLen = 700;
      var ex = px(tr.P2[0] + tr.d2[0]*extLen), ey = py(tr.P2[1] + tr.d2[1]*extLen);
      svg.push('<line x1="'+px(tr.P2[0]).toFixed(1)+'" y1="'+py(tr.P2[1]).toFixed(1)+'" x2="'+ex.toFixed(1)+'" y2="'+ey.toFixed(1)+'" stroke="'+rayColor+'" stroke-width="1.4" opacity="0.75"/>');
    }
  });

  // source marker for point / angled
  if (s.sourceType === 'point') {
    var built0 = ldBuildRay(0, {type:'point', objDist:s.objDist});
    var sx = Math.max(px(built0.P0[0]), leftEdge), sy = py(0);
    svg.push('<circle cx="'+sx.toFixed(1)+'" cy="'+sy.toFixed(1)+'" r="3.5" fill="'+rayColor+'"/>');
  }

  svg.push('<text x="'+(cx-14)+'" y="'+(cy+16)+'" font-family="IBM Plex Mono, monospace" font-size="9" fill="rgba(74,127,165,0.5)">n='+s.n.toFixed(3)+'</text>');

  return '<svg viewBox="0 0 '+LD_VB_W+' '+LD_VB_H+'" preserveAspectRatio="xMidYMid meet" style="width:100%;height:auto;display:block;">'+svg.join('')+'</svg>';
}

/* ---------- readouts + copy-spec ---------- */
function ldSourceLabel(s) {
  if (s.sourceType === 'point') return 'Point Source (' + s.objDist.toFixed(0) + ' mm)';
  if (s.sourceType === 'angled') return 'Angled Beam (' + s.angleDeg.toFixed(1) + '\u00b0)';
  return 'Collimated (\u221e)';
}

function ldBuildSpecTiles(o) {
  function tile(val, unit, label) {
    return '<div class="ld-spec"><div class="ld-sv">'+val+'</div><div class="ld-su">'+unit+'</div><div class="ld-sl">'+label+'</div></div>';
  }
  return tile(ldFmt(o.f,1), 'mm', 'EFL (effective)') +
         tile(ldFmt(o.BFD,1), 'mm', 'Back Focal Dist.') +
         tile(isNaN(o.fnum) ? '\u2014' : 'f/'+o.fnum.toFixed(1), '', 'f-number') +
         tile(isNaN(o.NA) ? '\u2014' : o.NA.toFixed(3), '', 'NA') +
         tile(isFinite(o.powerD) ? o.powerD.toFixed(2) : '\u2014', 'D', 'Optical Power');
}

function ldBuildReadouts(s, o, cls, warn, bundle, focusSpread) {
  var imgDist = bundle.conv ? (bundle.conv.x - s.t) : null;
  var imgHeight = bundle.conv ? bundle.conv.y : null;
  var imgReal = bundle.conv ? bundle.conv.real : null;
  var items = [
    ['Shape', cls.shape],
    ['Behavior', cls.behavior],
    ['Light Source', ldSourceLabel(s)],
    ['Focal Length (thin approx.)', ldFmt(o.fThin,2)+' mm'],
    ['Image Dist. (ray-traced)', imgDist===null?'\u2014':(ldFmt(imgDist,2)+' mm'+(imgReal===false?' (virtual)':''))],
    ['Off-axis Image Height', imgHeight===null?'\u2014':ldFmt(imgHeight,2)+' mm'],
    ['Center / Edge Thickness', s.t.toFixed(2)+' / '+(warn.edgeThickness===null?'\u2014':warn.edgeThickness.toFixed(2))+' mm'],
    ['Edge Angle (front / back)', (warn.slope1deg===null?'\u2014':warn.slope1deg.toFixed(1))+'\u00b0 / '+(warn.slope2deg===null?'\u2014':warn.slope2deg.toFixed(1))+'\u00b0'],
    ['Focus Spread (spherical ab. proxy)', focusSpread===null?'N/A':focusSpread.toFixed(3)+' mm'],
    ['Rays: aperture-clipped / TIR', bundle.apertureClipCount+' / '+bundle.tirCount]
  ];
  return items.map(function(it){
    return '<div class="ld-readout"><div class="ld-r-label">'+it[0]+'</div><div class="ld-r-value">'+it[1]+'</div></div>';
  }).join('');
}

function ldVerifyLine(s, o) {
  if (!isFinite(o.BFD)) return 'System is afocal (or beyond floating-point range) \u2014 no finite focus to verify.';
  var h = Math.max(0.01, s.diameter*0.001);
  var hit = ldTraceRay([-1000,h],[1,0],s);
  if (hit.clipped || !hit.d2) return 'Paraxial ray-trace check unavailable for this geometry.';
  var u = -hit.P2[1]/hit.d2[1];
  var crossX = hit.P2[0] + u*hit.d2[0];
  var tracedBFD = crossX - s.t;
  var err = Math.abs(tracedBFD - o.BFD);
  return 'Paraxial ray-trace vs. closed-form thick-lens formula: BFD '+tracedBFD.toFixed(4)+' mm vs '+o.BFD.toFixed(4)+' mm (\u0394='+err.toExponential(1)+') '+(err<1e-2?'\u2713':'\u26a0');
}

function ldCopySpecText(s, o, cls, warn) {
  var lines = [];
  lines.push('OptiSil Lens Designer \u2014 spec summary');
  lines.push('Shape: ' + cls.shape + ' (' + cls.behavior + ')');
  lines.push('Diameter: ' + s.diameter.toFixed(1) + ' mm, Center thickness: ' + s.t.toFixed(2) + ' mm');
  lines.push('R1 (front): ' + (s.r1flat ? '\u221e (flat)' : s.R1.toFixed(1)+' mm') + (s.k1||s.A4_1||s.A6_1 ? ('  [\u03ba='+s.k1.toFixed(2)+', A4='+s.A4_1.toExponential(2)+', A6='+s.A6_1.toExponential(2)+']') : ''));
  lines.push('R2 (back): ' + (s.r2flat ? '\u221e (flat)' : s.R2.toFixed(1)+' mm') + (s.k2||s.A4_2||s.A6_2 ? ('  [\u03ba='+s.k2.toFixed(2)+', A4='+s.A4_2.toExponential(2)+', A6='+s.A6_2.toExponential(2)+']') : ''));
  lines.push('Material: n = ' + s.n.toFixed(3));
  lines.push('Light source: ' + ldSourceLabel(s));
  lines.push('EFL (effective): ' + ldFmt(o.f,2) + ' mm, BFD: ' + ldFmt(o.BFD,2) + ' mm, Power: ' + (isFinite(o.powerD)?o.powerD.toFixed(2):'\u2014') + ' D');
  lines.push('f-number: ' + (isNaN(o.fnum)?'\u2014':'f/'+o.fnum.toFixed(2)) + ', NA: ' + (isNaN(o.NA)?'\u2014':o.NA.toFixed(3)));
  lines.push('Edge thickness: ' + (warn.edgeThickness===null?'\u2014':warn.edgeThickness.toFixed(2)+' mm') + ', Edge angles: ' + (warn.slope1deg===null?'\u2014':warn.slope1deg.toFixed(1)+'\u00b0/'+warn.slope2deg.toFixed(1)+'\u00b0'));
  if (warn.list.length) {
    lines.push('Manufacturability flags:');
    warn.list.forEach(function(w){ lines.push('  - ' + w); });
  } else {
    lines.push('Manufacturability check: no issues flagged.');
  }
  return lines.join('\n');
}

/* ---------- DOM wiring ---------- */
function ld$(id){ return document.getElementById(id); }

function ldReadState() {
  LD.diameter = parseFloat(ld$('ld-diameter-n').value);
  LD.t = parseFloat(ld$('ld-thick-n').value);
  LD.r1flat = ld$('ld-r1flat').checked;
  LD.r2flat = ld$('ld-r2flat').checked;
  LD.R1 = (LD.R1 >= 0 ? 1 : -1) * parseFloat(ld$('ld-r1-n').value);
  LD.R2sign = LD.R2 >= 0 ? 1 : -1;
  LD.R2 = LD.R2sign * parseFloat(ld$('ld-r2-n').value);
  LD.k1 = parseFloat(ld$('ld-k1-n').value);
  LD.k2 = parseFloat(ld$('ld-k2-n').value);
  LD.A4_1 = parseFloat(ld$('ld-a4-1-n').value) * 1e-5;
  LD.A4_2 = parseFloat(ld$('ld-a4-2-n').value) * 1e-5;
  LD.A6_1 = parseFloat(ld$('ld-a6-1-n').value) * 1e-7;
  LD.A6_2 = parseFloat(ld$('ld-a6-2-n').value) * 1e-7;
  LD.n = parseFloat(ld$('ld-n-n').value);
  LD.objDist = parseFloat(ld$('ld-objdist-n').value);
  LD.angleDeg = parseFloat(ld$('ld-angle-n').value);
}

function ldUpdate() {
  ldReadState();

  // restrict the diameter slider to the range that keeps the geometry valid
  var maxValidD = ldMaxValidDiameter(LD);
  var sliderMax = Math.max(8, Math.min(150, maxValidD));
  ld$('ld-diameter-r').max = sliderMax;
  ld$('ld-diameter-n').max = sliderMax;
  if (LD.diameter > sliderMax) {
    LD.diameter = sliderMax;
    ld$('ld-diameter-r').value = sliderMax;
    ld$('ld-diameter-n').value = sliderMax;
  }

  var s = LD;
  var o = ldOptics(s);
  var cls = ldClassify(s, o);
  var warn = ldWarnings(s);
  var bundle = ldTraceBundle(s);
  var focusSpread = ldFocusSpread(bundle, s.diameter/2);

  if (bundle.tirCount > 0) {
    warn.list = warn.list.concat(['Total internal reflection on ' + bundle.tirCount + ' of ' + bundle.rays.length +
      ' traced rays \u2014 those rays do not exit the lens as drawn. Check the index/curvature combination at this aperture.']);
  }

  ld$('ld-specs').innerHTML = ldBuildSpecTiles(o);
  ld$('ld-readouts').innerHTML = ldBuildReadouts(s, o, cls, warn, bundle, focusSpread);
  ld$('ld-verify').textContent = ldVerifyLine(s, o);
  ld$('ld-stage').innerHTML = ldBuildSVG(s, o, bundle, warn, focusSpread);

  var wbox = ld$('ld-warnings');
  if (warn.list.length) {
    wbox.style.display = 'block';
    ld$('ld-warnings-list').innerHTML = warn.list.map(function(w){ return '<li>'+w+'</li>'; }).join('');
  } else {
    wbox.style.display = 'none';
  }

  // live value labels next to sliders
  ld$('ld-diameter-v').textContent = s.diameter.toFixed(0)+' mm' + (sliderMax < 150 ? ' (capped at ' + sliderMax.toFixed(0) + ' mm)' : '');
  ld$('ld-thick-v').textContent = s.t.toFixed(1)+' mm';
  ld$('ld-r1-v').textContent = s.r1flat ? '\u221e' : Math.abs(s.R1).toFixed(0)+' mm';
  ld$('ld-r2-v').textContent = s.r2flat ? '\u221e' : Math.abs(s.R2).toFixed(0)+' mm';
  ld$('ld-k1-v').textContent = s.k1.toFixed(2);
  ld$('ld-k2-v').textContent = s.k2.toFixed(2);
  ld$('ld-n-v').textContent = s.n.toFixed(3);
  ld$('ld-objdist-v').textContent = s.objDist.toFixed(0)+' mm';
  ld$('ld-angle-v').textContent = s.angleDeg.toFixed(1)+'\u00b0';

  LD._lastOptics = o; LD._lastClass = cls; LD._lastWarn = warn;
}

function ldSyncPair(rangeId, numId) {
  var r = ld$(rangeId), n = ld$(numId);
  r.addEventListener('input', function(){ n.value = r.value; ldUpdate(); });
  n.addEventListener('input', function(){
    var v = parseFloat(n.value);
    if (isNaN(v)) return;
    var clamped = Math.min(Math.max(v, parseFloat(r.min)), parseFloat(r.max));
    r.value = clamped;
    ldUpdate();
  });
}

function ldSetShape(key) {
  ldApplyShapePreset(key);
  ld$('ld-r1-n').value = Math.abs(LD.R1).toFixed(0);
  ld$('ld-r1-r').value = Math.abs(LD.R1).toFixed(0);
  ld$('ld-r2-n').value = Math.abs(LD.R2).toFixed(0);
  ld$('ld-r2-r').value = Math.abs(LD.R2).toFixed(0);
  ld$('ld-r1flat').checked = LD.r1flat;
  ld$('ld-r2flat').checked = LD.r2flat;
  document.querySelectorAll('.ld-shape-btn').forEach(function(b){ b.classList.toggle('on', b.dataset.shape===key); });
  ldUpdate();
}

function ldSetSource(type) {
  LD.sourceType = type;
  document.querySelectorAll('.ld-src-btn').forEach(function(b){ b.classList.toggle('on', b.dataset.src===type); });
  ld$('ld-objdist-row').style.display = type === 'point' ? 'flex' : 'none';
  ld$('ld-angle-row').style.display = type === 'angled' ? 'flex' : 'none';
  ldUpdate();
}

function ldApplyMaterial() {
  var idx = ld$('ld-material').value;
  if (idx === '') return;
  var m = LD_MATERIALS[parseInt(idx,10)];
  ld$('ld-n-n').value = m.n.toFixed(3);
  ld$('ld-n-r').value = m.n.toFixed(3);
  ldUpdate();
}

function ldCopySpec() {
  var text = ldCopySpecText(LD, LD._lastOptics, LD._lastClass, LD._lastWarn);
  var status = ld$('ld-copy-status');
  function done(ok){ status.textContent = ok ? 'Copied to clipboard.' : 'Copy failed \u2014 select and copy manually.'; setTimeout(function(){status.textContent='';}, 3000); }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(function(){done(true);}).catch(function(){ ldFallbackCopy(text, done); });
  } else {
    ldFallbackCopy(text, done);
  }
}
function ldFallbackCopy(text, done) {
  try {
    var ta = document.createElement('textarea');
    ta.value = text; ta.style.position='fixed'; ta.style.opacity='0';
    document.body.appendChild(ta); ta.focus(); ta.select();
    var ok = document.execCommand('copy');
    document.body.removeChild(ta);
    done(ok);
  } catch(e) { done(false); }
}

function ldInit() {
  ['ld-diameter','ld-thick','ld-r1','ld-r2','ld-k1','ld-k2','ld-a4-1','ld-a4-2','ld-a6-1','ld-a6-2','ld-n','ld-objdist','ld-angle'].forEach(function(id){
    ldSyncPair(id+'-r', id+'-n');
  });
  ['ld-r1flat','ld-r2flat'].forEach(function(id){ ld$(id).addEventListener('change', ldUpdate); });
  ldApplyShapePreset('biconvex');
  ldUpdate();
}

// Initialise once the DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ldInit);
} else {
  ldInit();
}
